// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__dpLsN","customError":"ErrorPage_customError__1p5S9","content":"ErrorPage_content__YCqXh","actions":"ErrorPage_actions__LpHk3"};